if (typeof Hromadny_Tisk === 'undefined') {

    var Hromadny_Tisk = {
        init: function () {
            var tlacitko = $('#tlacitko-hromadny-tisk');
            if (!tlacitko.length) {
                return;
            }

            tlacitko
                .off('click')
                .on('click', function (e) {
                    e.preventDefault();

                    var grid = $('#grid_section_i103');
                    var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                    if (!rows.length) {
                        Lemo_Alert.addInfo('Pro tisk označte alespoň jednu žádost', 'tiskZadostiInfo');
                        return;
                    }

                    var ids = [];
                    $.each(rows, function (i, id) {
                        ids.push(id);
                    });

                    $.ajax({
                        type: 'post',
                        url: '/plugin/PluginZadost/hromadnyTiskFormularAjax',
                        dataType: 'json',
                        data: {'ids': ids},
                        global: false,
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Načítám formulář ...', 'hromadnyTiskFormular');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('hromadnyTiskFormular');
                        },
                        success: function (data) {
                            Lemo_Alert.addMany(data.messages);
                            if (
                                false === data['status']
                                || !data.hasOwnProperty('html')
                                || !data['html'].length
                            ) {
                                return;
                            }

                            // modal
                            Lemo_Modal.setSize('large');
                            Lemo_Modal.setTitle('Hromadný tisk dokumentů');
                            Lemo_Modal.setContent(data.html);
                            Lemo_Modal.addButton('sloucit-dokumenty', 'Sloučit dokumenty pro tisk', 'btn btn-primary', function (e) {
                                e.preventDefault();
                                Lemo_Alert.closeAll();
                                var typy = $('#modal-hromadny-tisk-dokumentu').find( "input:checked");
                                if (!typy.length) {
                                    Lemo_Alert.addInfo('Vypberte alespoň jeden typ dokumentu');
                                } else {
                                    var typyIds = [];
                                    typy.each(function(i, element) {
                                        typyIds.push($(element).val());
                                    });

                                    Hromadny_Tisk.akce(ids, typyIds);
                                    Lemo_Modal.close();
                                }

                            });
                            Lemo_Modal.addButton('cancel', 'Zrušit', 'btn btn-default', function () {
                                Lemo_Alert.closeAll();
                                Lemo_Modal.close();
                            });
                            Lemo_Modal.build();
                        }
                    });
                });
        },

        /**
         * @param {array} ids
         * @param {array} typyIds
         */
        akce: function (ids, typyIds) {

            var progressId = 'hromadny-tisk-' + Math.round(new Date().getTime() + (Math.random() * 100));

            $.ajax({
                type: 'post',
                url: '/plugin/PluginZadost/hromadnyTiskAjax',
                dataType: 'json',
                global: true,
                data: {'progressId': progressId, 'ids': ids, 'typyIds': typyIds},
                beforeSend: function () {
                    var text = '<p id="export-progress-eta">Příprava operace ...</p>';
                    text += '<div id="export-progress" class="progress text-center mb-3">';
                    text += '    <div class="progress-bar progress-bar-animated active" role="progressbar" style="width: 0;">0%</div>';
                    text += '</div>';
                    text += '<p id="export-progress-message" class="text-monospace"></p>';

                    Lemo_Alert.setShowCloseButton(false);
                    Lemo_Alert.setCloseOnClick(false);
                    Lemo_Alert.build('info', 'Hromadný tisk dokumentů', text, 'ajaxProgress', 0);
                    Lemo_Alert.setShowCloseButton(true);
                    Lemo_Alert.setCloseOnClick(true);

                    Plugin_Zadost.progressInterval = window.setInterval(function() {
                        Plugin_Zadost.ajaxProgress(progressId);
                    }, 2500);

                },
                complete: function () {
                    Lemo_Alert.closeById('ajaxProgress');
                    if (null !== Plugin_Zadost.progressInterval) {
                        window.clearInterval(Plugin_Zadost.progressInterval);
                        Plugin_Zadost.progressInterval = null;
                    }
                },
                success: function (data) {
                    if (data.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(data.messages);
                    }

                    if (true === data['status']) {
                        window.location.href = '/plugin/PluginZadost/hromadnyTiskStazeni?id=' + progressId;
                    }
                },
                error: function (xhr) {
                    Lemo_Alert.addDanger('Při generování dokumentu došlo k neočekávané chybě', 'hromadnyTiskException');
                }
            });
        },
    }
}

$(document)
    .ready(function () {
        Hromadny_Tisk.init();
    });